import React from 'react';
import { addMonths } from 'date-fns';
import DatePicker from '@nib-components/date-picker';
import FormControl from '@nib-components/form-control';
import { errorMessage, isValid, isTouched } from '../../util/validationHelpers';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS } from '../../util/constants';
import { combineHandlerWithFormik } from '../../util/eventHelpers';
import { defaultFieldPropTypes } from '../../types';
const INTERNATIONAL_LABEL = 'Estimated cover start date';
const LABELS = {
  ARHI: DEFAULT_LABELS.COVER_START_DATE,
  IMAN: INTERNATIONAL_LABEL,
  IWHI: INTERNATIONAL_LABEL,
  ISHI: INTERNATIONAL_LABEL
};
const todayDate = new Date();
const CoverStartDate = props => {
  const {
    funnel = 'ARHI',
    months = 24,
    minDate = todayDate,
    width = 15,
    fullstory = 'mask',
    id,
    label,
    help,
    field,
    form,
    onBlur,
    onChange,
    disabled,
    ...otherProps
  } = props;
  const formikOnChangeOrBlur = e => {
    // PHISL-4918 - If they have selected a data update it, if not just set it to it's current value.
    // we want to set it if unchanged though as this will force it to validate.
    const value = e instanceof Date ? e : field === null || field === void 0 ? void 0 : field.value;
    if (form && form.setFieldValue && form.setFieldTouched) {
      form.setFieldValue(id, value);
      form.setFieldTouched(id, true);
    }
  };
  const handleBlur = combineHandlerWithFormik(formikOnChangeOrBlur, onBlur);
  const handleChange = combineHandlerWithFormik(formikOnChangeOrBlur, onChange);
  const validState = isValid({
    ...otherProps,
    form,
    id
  });
  const validatedState = isTouched({
    ...otherProps,
    form,
    id
  });
  const errorState = errorMessage({
    ...otherProps,
    form,
    id
  });
  const helpText = help || `Your cover start date must be within ${months} month${months !== 1 ? 's' : ''} of today's date.`;
  return React.createElement(FormControl, {
    fullstory: fullstory,
    name: field === null || field === void 0 ? void 0 : field.name,
    id: id,
    label: label || LABELS[funnel] || LABELS.ARHI,
    help: helpText,
    valid: validState,
    validated: validatedState,
    error: errorState,
    width: width,
    disabled: disabled
  }, React.createElement(DatePicker, {
    ...field,
    value: field === null || field === void 0 ? void 0 : field.value,
    selected: field === null || field === void 0 ? void 0 : field.value,
    onChange: handleChange,
    onBlur: handleBlur,
    minDate: minDate,
    maxDate: addMonths(minDate, months),
    shouldCloseOnSelect: true,
    autoComplete: "off",
    ...otherProps
  }));
};
CoverStartDate.defaultProps = {
  ...defaultFieldPropTypes,
  months: 24,
  width: 15
};
const CoverStartDateWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(CoverStartDate, {
  ...props
}));
export default CoverStartDateWithFunnel;